import { validates } from '../utils/ValidateFormObject'

const webinar = {
  tipo: {
    required: true
  },
  titulo: {
    required: true
  },
  autores: {
    required: true
  },
  especialidades: {
    required: true
  },
  pesoDA: {
    required: true
  },
  idioma: {
    required: true
  },
  palavrasChave: {
    required: true
  },
  codigo: {
    required: true
  },
  tituloCurso: {
    required: true
  },
  autoresCurso: {
    required: true
  },
  copyrightCurso: {
    required: true,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  edicaoCurso: {
    required: true
  },
  codigoProtheus: {
    required: true,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  especialidadesCurso: {
    required: true
  },
  tituloModulo: {
    required: true
  },
  autoresModulo: {
    required: true
  },
  textoModulo: {
    required: false
  },
  descricao: {
    required: false
  },
  cursoReferencia: {
    required: false
  }
}

export default webinar



// WEBPACK FOOTER //
// ./src/contentSchema/webinar.js